import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import VerticalOverviewElements from "./routes/VerticalOverviewElements";
import HorizontalOverviewElements from "./routes/HorizontalOverviewElements";
import CurriculumMapsElements from "./routes/CurriculumMapsElements";
import OverallProgrammeInsights from "./routes/OverallProgrammeInsights";
import ProgrammeOverview from "./routes/ProgrammeOverview";
import InsightV2 from "./routes/InsightV2";
import UnitPlanDetails from "UnitPlanDetails/index.v2";
import SubjectOverview from "./routes/SubjectOverview";
import SubjectViews from "./routes/SubjectViews";
export default store => ({
  path: "planningInsights",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "planning-insights" */ "./components"),
        import(/* webpackChunkName: "planning-insights" */ "./modules/Module"),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "planningInsights",
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [
    VerticalOverviewElements(store),
    HorizontalOverviewElements(store),
    CurriculumMapsElements(store),
    SubjectOverview(store),
    SubjectViews(store),
    OverallProgrammeInsights(store),
    ProgrammeOverview(store),
    UnitPlanDetails(store),
    InsightV2(store),
  ],
});
